import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { environment } from 'src/environments/environment';
import { JsonDialogComponent } from "src/app/components/custom-forms/json-dialog/json-dialog.component";

@Component({
  selector: 'app-contactflowreport',
  templateUrl: './contactflowreport.component.html',
  styleUrls: ['./contactflowreport.component.css']
})
export class ContactflowreportComponent implements OnInit {

  contactFlows: any[] = [];
  filterdData: any[] = [];

  // these arrays are used for filter options
  lambdas: string[] = [];
  queues: string[] = [];
  callFlows: string[] = [];
  lambdaFilter: string = "";
  queueFilter: string = "";
  contactFlowFilter: string = "";

  lambdaMessage: string = "";
  lambdaError: boolean = false;
  additionalFilters: boolean = false;

  constructor(private telecomService:TelecomService, public dialog:MatDialog) { }

  ngOnInit(): void {
    this.getData();
  }

  getData(){
    this.lambdaMessage = "";
    this.lambdaError = false;
    let params = {
      FunctionName: environment.GetContactFlowReportLambdaName,
    };
    this.telecomService.callLambda(params, 'An error occurred while trying to retrieve contact flow data: ').then((response: any) => {
      console.log("contact flow data: ", response);
      if(response.status == 200){
        this.contactFlows = response.data;
        this.filterdData = JSON.parse(JSON.stringify(this.contactFlows));
        this.buildFilterData();
      }else{
        console.error(response.message);
        this.lambdaError = true;
        this.lambdaMessage = "Failed to retrieve contact flow report."
      }
    });
  }

  setQueueFilter(event){
    this.queueFilter = event.value;
  }

  setContactFlowFilter(event){
    this.contactFlowFilter = event.value;
  }

  setLambdaFilter(event){
    this.lambdaFilter = event.value;
  }

  buildFilterData(){
    this.lambdas = [];
    this.queues = [];
    this.callFlows = [];

    this.contactFlows.forEach(contactFlow => {
      
      contactFlow.contactFlows.forEach(cf => {
        if(this.callFlows.indexOf(cf.text) == -1){
          this.callFlows.push(cf.text);
        }
      });

      contactFlow.queues.forEach(queue => {
        if(this.queues.indexOf(queue.text) == -1){
          this.queues.push(queue.text);
        }
      });

      contactFlow.lambdas.forEach(lambda => {
        var name = this.getLambdaName(lambda);
        if(this.lambdas.indexOf(name) == -1){
          this.lambdas.push(name);
        }
      });
    });
    console.info(`${this.queues.length} queues, ${this.callFlows.length} child contact flows, ${this.lambdas.length} lambdas`);
  }

  applyAdvancedFilter(){
    let data = JSON.parse(JSON.stringify(this.contactFlows));
    console.log(this.contactFlows.length);

    console.info("queue filter: ", this.queueFilter);
    if(this.queueFilter != ""){
      data = data.filter(flow => {
        for(let i=0; i<flow.queues.length; i++){
          if(flow.queues[i].text.includes(this.queueFilter)){
            return true;
          }
        }
        return false;
      });
    }

    console.info("contact flow filter: ", this.contactFlowFilter);
    if(this.contactFlowFilter != ""){
      data = data.filter(flow => {
        for(let i=0; i<flow.contactFlows.length; i++){
          if(flow.contactFlows[i].text.includes(this.contactFlowFilter)){
            return true;
          }
        }
        return false;
      });
    }

    console.info("lambda filter: ", this.lambdaFilter);
    if(this.lambdaFilter != ""){
      data = data.filter(flow => {
        for(let i=0; i<flow.lambdas.length; i++){
          try{
            if(flow.lambdas[i].LambdaFunctionARN.includes(this.lambdaFilter)){
              return true;
            }
          }catch{
            console.error(flow.lambdas[i]);
          }
        }
        return false;
      });
    }

    console.info("filter results: ", data.length);
    this.filterdData = JSON.parse(JSON.stringify(data));
  }

  removeAdvancedFilter(){
    this.lambdaFilter = "";
    this.contactFlowFilter = "";
    this.queueFilter = "";
    this.filterdData = JSON.parse(JSON.stringify(this.contactFlows));
  }

  handleButtonEvent(event:any){
    console.log(event);
  }

  copyText(text){
    navigator.clipboard.writeText(text)
  }

  getLambdaName(lambda){
    const re = /(-|_)/
    let name = lambda.LambdaFunctionARN.split(":").slice(-1)[0].split(re).slice(-5).join("");
    return name;
  }

}
